import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { Grid, LinearProgress, Typography } from "@mui/material";

import { useAxios } from "../../../../hooks";
import { Autocomplete } from "../../../../components";
import BodyVariable from "../../../broadcast reminder components/details components/template details components/BodyVariable";
import HeaderVariable from "../../../broadcast reminder components/details components/template details components/HeaderVariable";
import ButtonVariable from "../../../broadcast reminder components/details components/template details components/ButtonVariable";

export function SendMessageAction({ fields, setTemp, formikProps, editState }) {
  const axios = useAxios();
  const { activeBot } = useSelector((state) => state.memberDetails);

  const [template, setTemplate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templateData, setTemplateData] = useState({});

  useEffect(() => {
    axios({
      url: "/wa/template/" + activeBot.ID + "?is_active=1&verified_status=3",
      method: "GET",
    }).then((response) => {
      if (response.status) {
        setTemplate(response.data.temp_obj);
      }
    });

    if (formikProps.values.actionID) {
      setLoading(true);
      axios({
        url:
          "/wa/template/variable/" +
          activeBot.ID +
          "/" +
          formikProps.values.templateID,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setTemplateData(response.data);
        }
      });
      setLoading(false);
    }
  }, [
    axios,
    activeBot.ID,
    formikProps.values.actionID,
    formikProps.values.templateID,
  ]);

  return (
    <Fragment>
      <Grid item xs={4} mb={5}>
        <Autocomplete
          name="templateID"
          label="Select Template"
          defaults={{
            primaryKey: "_id",
            displayLabel: "name",
          }}
          options={template}
          onChange={(_, value, type) => handleChangeTemplate(value, type)}
          formikProps={formikProps}
          disableField={!editState}
        />
      </Grid>

      {loading ? (
        <Fragment>
          <Grid item xs={12} style={{ justifyContent: "center" }}>
            <Typography variant="h5" style={{ display: "flex" }}>
              Loading template variables{" "}
              <LinearProgress
                style={{
                  width: "55px",
                  position: "relative",
                  top: "9.5px",
                  marginLeft: "5px",
                }}
              />
            </Typography>
          </Grid>
        </Fragment>
      ) : (
        <Fragment>
          {Boolean(templateData?.variables?.body.length) && (
            <Grid item xs={12}>
              <BodyVariable
                data={formikProps.values.templateName}
                dialogFormikProps={formikProps}
                templateData={templateData}
                formikProps={{
                  values: {
                    templateID: formikProps.values.templateID,
                  },
                }}
                fields={fields}
                editState={editState}
              />
            </Grid>
          )}

          {Boolean(templateData?.variables?.header.length) && (
            <Grid item xs={12}>
              <HeaderVariable
                data={formikProps.values.templateName}
                dialogFormikProps={formikProps}
                templateData={templateData}
                formikProps={{
                  values: {
                    templateID: formikProps.values.templateID,
                  },
                }}
                fields={fields}
                editState={editState}
              />
            </Grid>
          )}

          {Boolean(templateData?.variables?.button.length) && (
            <Grid item xs={12}>
              <ButtonVariable
                data={formikProps.values.templateName}
                dialogFormikProps={formikProps}
                templateData={templateData}
                formikProps={{
                  values: {
                    templateID: formikProps.values.templateID,
                  },
                }}
                fields={fields}
                editState={editState}
              />
            </Grid>
          )}
        </Fragment>
      )}
    </Fragment>
  );

  function handleChangeTemplate(value, type) {
    setLoading(true);

    formikProps.setValues((prev) => ({
      ...prev,
      templateID: value._id,
      templateName: value.name,
    }));
    setTemp(value.name);
    axios({
      url: "/wa/template/variable/" + activeBot.ID + "/" + value._id,
      method: "GET",
      disableRedirect: true,
    }).then(async (response) => {
      if (response.status) {
        let res = response.data;
        setTemplateData(res);

        await formikProps.setValues((prev) => ({
          ...prev,
          [value.name]: {
            templateID: value._id,
            ...(res?.variables?.header?.length !== 0 && {
              header_variable: Array(
                res.template_data?.template_header?.count_of_variable
              ).fill({
                variable_default_value: "",
                variable_name: "",
                variable_value: "",
                file_name: "",
                variable_value_type: "custom",
              }),
            }),
            ...(res?.variables?.body?.length !== 0 && {
              body_variable: Array(
                res.template_data?.template_body?.count_of_variable
              ).fill({
                variable_default_value: "",
                variable_name: "",
                variable_value: "",
                variable_value_type: "custom",
              }),
            }),
            ...(res?.variables?.button?.length !== 0 && {
              button_variable: Array(
                res.template_data?.template_button?.count_of_variable
              ).fill({
                variable_default_value: "",
                variable_name: "",
                variable_value: "",
                variable_value_type: "custom",
              }),
            }),
          },
        }));

        setLoading(false);
      }
    });
  }
}
